export default __webpack_public_path__ + "static/media/whitepaper-v1.981796a3.pdf";